import { useAtomValue } from 'jotai';
import { useMemo } from 'react';

import { v2ContainerSizeAtom, v2ZoomAtom } from '../../store/v2/viewer.atom';

const FIT_PADDING = 32;

interface Props {
  originalWidth: number;
  originalHeight: number;
}

/**
 * fit-page 기준 페이지 렌더 크기를 계산한다.
 * zoom=1이 fit-page(100%)가 되도록 픽셀 폭 기반으로 페이지 크기를 산출한다.
 */
const useFitZoom = ({ originalWidth, originalHeight }: Props) => {
  const containerSize = useAtomValue(v2ContainerSizeAtom);
  const zoom = useAtomValue(v2ZoomAtom);

  return useMemo(() => {
    const aspect = originalWidth / originalHeight || 1;
    const availableWidth = Math.max(containerSize.width - FIT_PADDING, 0);
    const availableHeight = Math.max(containerSize.height - FIT_PADDING, 0);

    const fitPageWidth =
      Math.min(availableWidth, availableHeight * aspect) || 0;
    const fitWidthZoom = fitPageWidth > 0 ? availableWidth / fitPageWidth : 1;

    const renderedWidth = fitPageWidth * zoom;
    const renderedHeight = aspect > 0 ? renderedWidth / aspect : 0;

    return {
      fitPageWidth,
      fitWidthZoom,
      renderedWidth,
      renderedHeight,
      aspect,
    };
  }, [containerSize, originalWidth, originalHeight, zoom]);
};

export default useFitZoom;
